import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import styles from "./MetaphorExercisesSection.module.css";
import { renderText } from "../../utils/templateRenderer";

export default function TemperamentSection({
  derivedArchetype = {},
  canViewPremium = false,
}) {
  const { t } = useTranslation("user");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const modalRef = useRef(null);
  const openerRef = useRef(null);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      setTimeout(() => modalRef.current && modalRef.current.focus(), 50);
    } else {
      document.body.style.overflow = "";
      if (openerRef.current) openerRef.current.focus();
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <section className={styles.reportSection}>
      <header className={styles.header}>
        <h3>{t("profile.tempTitle")}</h3>
        <p>{t("profile.tempText")}</p>
      </header>
      <div className={styles.topRow}>
        <div className={styles.exercisesBox}>
          <strong>{t("profile.tempModelTitle")}</strong>
          <div
            style={{
              display: "flex",
              gap: 12,
              alignItems: "center",
              marginTop: 8,
            }}
          >
            {derivedArchetype.image && (
              <div
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: 8,
                  overflow: "hidden",
                  background: "#f3f4f6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={derivedArchetype.image}
                  alt={derivedArchetype.label}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}
            <div>
              <div style={{ fontWeight: 700 }}>
                {t("profile.tempModelText")}
                {derivedArchetype?.meta?.label || ""}
              </div>
              <div style={{ color: "#6b7280", fontSize: 14 }}>
                {derivedArchetype?.meta?.description}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.metaphorBox}>
          <p>
            <strong>{t("profile.tempMetaphor")}</strong>{" "}
            {derivedArchetype.story.metaphor}
          </p>

          <div className={styles.metaphorWrap}>
            <p>{derivedArchetype.story.brief}</p>

            {!canViewPremium ? (
              <button
                className={styles.openBtn}
                onClick={() => navigate("/pricing")}
              >
                {t("profile.premiumFalseMetaphor1")}
                <br />
                {t("profile.premiumFalseMetaphor2")}
              </button>
            ) : (
              <button className={styles.openBtn} onClick={() => setOpen(true)}>
                {t("profile.premiumTrueMetaphor")}
              </button>
            )}
          </div>
        </div>
      </div>

      {open && (
        <div
          className={styles.modalBackdrop}
          role="dialog"
          aria-modal="true"
          aria-label={derivedArchetype.story.metaphor}
        >
          <div className={styles.modal} ref={modalRef} tabIndex={-1}>
            <div className={styles.modalHeader}>
              <div>
                <strong>{derivedArchetype.story.metaphor}</strong>
              </div>
              <button
                aria-label="Fechar"
                className={styles.closeBtn}
                onClick={() => setOpen(false)}
              >
                ✕
              </button>
            </div>

            <div className={styles.modalBody}>
              <div className={styles.modalPlaceholder}>
                {renderText(derivedArchetype?.story?.premium)}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
